<template>
  <div class="nav">
    <div class="industries-title">Industries</div>
    <div id="icons-container" class="icons-container">
      <div class="btn-nav up" @mousedown="scrollingButton(1)" @mouseup="clear()">
        <div></div>
      </div>
      <router-link
        tag="div"
        class="industries-icon"
        :class="index===0?'first-icon':''"
        v-for="(industrie, index) in industries"
        :key="industrie.name"
        :to="{ path: '/' + $route.params.lang + '/industries/' + industrie.name }"
      >{{ industrie.title }}</router-link>
      <div class="btn-nav down" @mousedown="scrollingButton(-1)" @mouseup="clear()">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout, clearTimeout } from 'timers'
export default {
  name: 'loval-nav',
  props: ['industries'],
  data () {
    return {
      timeout: ''
    }
  },
  methods: {
    scrollingButton (n) {
      document.querySelector('#icons-container').scrollTop += 50 * -n
      this.timeout = setTimeout(() => {
        this.scrollingButton(n)
      }, 200)
    },
    clear () {
      clearTimeout(this.timeout)
    }
  }
}
</script>
<style lang="scss" scoped>
$nav-width: var(--nav-width);
$active-arrow-width: var(--nav-arrow-width);
$icon-height: 80px;
.nav {
  overflow: hidden;
  width: calc(#{$active-arrow-width} + #{$nav-width});
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
}
.btn-nav {
  position: absolute;
  z-index: 1;
  color: var(--white);
  width: var(--nav-width);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 0;
}
.btn-nav.up {
  top: var(--nav-title-height);
  background-image: linear-gradient(#122129, #182c3840);
}
.btn-nav.down {
  bottom: 0;
  background-image: linear-gradient(#182c3840, #122129);
}
.btn-nav.up div,
.btn-nav.down div {
  border-style: solid;
}
.btn-nav.up div {
  border-width: 0px calc(var(--nav-width) / 4) 15px calc(var(--nav-width) / 4);
  border-color: transparent transparent #c0c6ca transparent;
}
.btn-nav.down div {
  border-color: #c0c6ca transparent transparent transparent;
  border-width: 15px calc(var(--nav-width) / 4) 0 calc(var(--nav-width) / 4);
}
.btn-nav.up div:hover {
  border-color: transparent transparent #ffffff transparent;
}
.btn-nav.down div:hover {
  border-color: #ffffff transparent transparent transparent;
}
.industries-title {
  color: var(--black);
  position: relative;
  background-color: var(--yellow);
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--nav-title-height);
  margin-bottom: 2px;
}
.icons-container {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 17px;
  box-sizing: content-box;
  height: calc(
    100vh - var(--header-height) - var(--footer-height) - (54px + 2px)
  );
  min-height: calc((2.5 * #{$icon-height}));
}
.industries-icon,
.industries-title {
  width: var(--nav-width);
}
.first-icon {
  margin-top: 0px !important;
}
.industries-icon {
  color: var(--white);
  background-color: var(--dark-blue);
  min-height: $icon-height;
  height: calc(
    (
        (100vh - var(--header-height) - var(--footer-height) - (54px + 2px)) /
          var(--industries)
      ) - 2px
  );
  text-align: center;
  margin: 2px 0px;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.industries-icon:hover,
.router-link-active {
  text-shadow: 1px 1px 2px black, 0 0 25px white, 0 0 5px white;
}
.router-link-active::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: calc(#{$active-arrow-width} * -1);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: calc(#{$icon-height}/ 2) 0 calc(#{$icon-height}/ 2)
    calc(#{$active-arrow-width} - 2px);
  border-color: transparent transparent transparent var(--dark-blue);
}
@media only screen and (min-width: 992px) {
  .icons-container {
    min-height: calc((3.5 * #{$icon-height}));
  }
}
@media only screen and (min-width: 1200px) {
  .icons-container {
    min-height: calc((5 * #{$icon-height}));
  }
}
</style>
